import { PipeTransform } from '@angular/core';
var CategoryImagesPipe = /** @class */ (function () {
    function CategoryImagesPipe() {
    }
    CategoryImagesPipe.prototype.transform = function (text, active) {
        switch (text) {
            case 'A':
                return 'sc-icon-2x sc-tab-selector-icon__icon_2x icon-vehiculo_automovil' + (active ? ' active' : '');
            case 'B':
                return 'sc-icon-3x sc-tab-selector-icon__icon_3x icon-vehiculo_camion' + (active ? ' active' : '');
            case 'C':
                return 'sc-icon-3x sc-tab-selector-icon__icon_3x icon-vehiculo_acoplado' + (active ? ' active' : '');
            case 'D':
                return 'sc-icon-3x sc-tab-selector-icon__icon_3x icon-vehiculo_tractor' + (active ? ' active' : '');
            case 'E':
                return 'sc-icon-3x sc-tab-selector-icon__icon_3x icon-vehiculo_moto' + (active ? ' active' : '');
            case 'F':
                return 'sc-icon-3x sc-tab-selector-icon__icon_3x icon-vehiculo_minibus' + (active ? ' active' : '');
            case 'G':
                return 'sc-icon-3x sc-tab-selector-icon__icon_3x icon-vehiculo_motorhome' + (active ? ' active' : '');
            default:
                return '';
        }
    };
    return CategoryImagesPipe;
}());
export { CategoryImagesPipe };
